import styled from 'styled-components';

const InputWrapper = styled.div`
  position: relative;
  display: block;

  > span {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: 0.4px;
    color: #666;
    margin: 4px 16px;
    -webkit-box-decoration-break: clone;
    box-decoration-break: clone;
  }

  + div {
    margin-top: 16px;
  }
`;

const InputStyled = styled.div`
  position: relative;
  display: block;

  > textarea {
    font-family: 'Arial';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    bottom: 8px;
    background: #fff;
    border: 1px solid #999;
    box-sizing: border-box;
    border-radius: 8px;
    height: 64px;
    width: 100%;
    min-height: 72px;
    padding: 24px 16px 8px;
    color: #333;
    resize: vertical;

    &.valid {
      border: 1px solid #009a00;
    }

    &.invalid {
      border: 1px solid #ab0000;
    }

    &::placeholder {
      font-size: 14px;
      line-height: 16px;
      letter-spacing: 0.15px;
      opacity: 0;
    }

    &:focus,
    &:active,
    &:not(:placeholder-shown) {
      outline: none;

      &::placeholder {
        opacity: 0.7;
        font-family: 'Arial';
      }

      ~ label {
        top: 1px;
        left: 16px;
        width: calc(100% - 32px);
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 14px;
        letter-spacing: 0.15px;
        color: #666;
        background-color: #ffff;
        padding: 6px 0px 0px 0px;
      }
    }
  }

  > label {
    padding: 5px 0 0;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #666;
    position: absolute;
    pointer-events: none;
    left: 16px;
    top: 12px;
    transition: 0.3s ease all;
    -moz-transition: 0.3s ease all;
    -webkit-transition: 0.3s ease all;

    &.mini {
      position: relative;
      opacity: 0.3;
      top: 6px;
      left: 16px;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 14px;
      letter-spacing: 0.15px;
      color: #666;
    }

    &.required {
      &::after {
        content: ' *';
        color: ${({ theme }) => theme.buttonPrimaryColor};
        font-weight: normal;
      }
    }

    &.valid {
      color: #009a00 !important;
    }

    &.invalid {
      color: #ab0000 !important;
    }
  }
`;

export default InputWrapper;
export { InputWrapper, InputStyled };
